"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrefixCls = void 0;
require("core-js/modules/es.array.concat.js");
var Util = _interopRequireWildcard(require("../../Util"));
var _config = require("../config");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useConfig = Util.useConfig;
var usePrefixCls = exports.usePrefixCls = function usePrefixCls(suffixCls, prefix, matPrefix) {
  var _useConfig = useConfig(),
    classPrefixConfig = _useConfig.classPrefix,
    matClassPrefixConfig = _useConfig.matClassPrefix;
  var finalClassPrefix;
  var matClassPrefix = matPrefix || matClassPrefixConfig;
  if (matClassPrefix) {
    // 如果有单独的物料类名前缀，则使用单独的
    finalClassPrefix = matClassPrefix;
  } else {
    // 如果没有特殊设置，则使用序号组合的类名前缀
    var classPrefix = prefix || classPrefixConfig;
    finalClassPrefix = "".concat(classPrefix, "m");
    if (_config.MATERIAL_ID) {
      finalClassPrefix = "".concat(classPrefix, "m").concat(_config.MATERIAL_ID);
    }
  }
  return suffixCls ? "".concat(finalClassPrefix, "-").concat(suffixCls) : "".concat(finalClassPrefix);
};